import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import { Form, Modal } from "@components";
import React, { useCallback, useContext } from "react";
import { useHistory } from "react-router";
import { Actions } from "../../../../../../screens/request/components/actions";
import CloseIcon from "@material-ui/icons/Close";
import { Api } from "@api";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { Environment } from "../../../../../../store";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

interface Props {
  id: 0;
  data: Environment | undefined;
  isOpen: boolean;
  onClickAdd: () => void;
  onClickClose: () => void;
}

type FormValues = {
  id: number;
  name: string;
  isActive: boolean;
};

type Key = keyof FormValues;

export const Envdetails: React.FC<Props> = ({
  id,
  data,
  isOpen,
  onClickAdd,
  onClickClose,
}) => {
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = React.useState<
    boolean
  >(false);
  const [pending, setPending] = React.useState(false);
  const initial_values = data;
  const [values, setValues] = React.useState<FormValues | undefined>(
    initial_values
  );
  const form = Form.useManager<FormValues>({
    id: 0,
    name: data ? data.name : "",
    isActive: data ? data.isActive : false,
  });

  function onChange(name: Key, value: any): void {
    console.log(value);
    form.set(Form.target.VALUE, [name, value]);
    validate([name, value]).then(([name, error]) => {
      form.set(Form.target.ERROR, [name, error]);
    });
  }

  function validate([name, value]: [string, any]): Promise<[Key, Error?]> {
    console.log(value);
    switch (name) {
      case "name":
        return Promise.resolve([name as Key, Form.Validators.hasValue(value)]);
      default:
        return Promise.resolve([name as Key]);
    }
  }

  function handleAddButtonClick(): void {
    setPending(true);
    Api.environment
      .editEnvironment(data ? data.id : id, {
        ...form.values,
      })
      .then(() => {
        setPending(false);
        setIsOpenConfirmationModal(false);
        form.reset();
        data = undefined;
        onClickClose();
        onClickAdd();
      })
      .catch((error) => {
        setPending(false);
        console.log("Error: Update Environment. " + error);
      });
  }

  function handleSubmitButtonClick(): void {
    Promise.all(Object.entries(form.values).map(validate)).then(
      (validations) => {
        const valid = validations.reduce((valid, [name, error]) => {
          return valid && !error;
        }, true);
        if (valid) {
          setIsOpenConfirmationModal(true);
        } else {
          validations.forEach(([name, error]) => {
            form.set(Form.target.ERROR, [name, error]);
          });
        }
      }
    );
  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const clickCloseBtn = () => {
    setValues(undefined);
    form.reset();
    data = undefined;
    onClickClose();
  };

  const handleClose = () => {
    setOpen(false);
  };
  const styles = (theme: Theme) =>
    createStyles({
      root: {
        margin: 0,
        padding: theme.spacing(2),
      },
      closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });

  const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  return (
    <Box mt={2} mb={2}>
      <Modal
        isOpen={isOpenConfirmationModal}
        positionButton="center"
        actions={[
          {
            label: "Cancel",
            variant: "outlined",
            handler: () => {
              setIsOpenConfirmationModal(false);
            },
          },
          {
            label: pending ? "Submitting..." : "Submit",
            handler: () => {
              handleAddButtonClick();
            },
            disabled: pending,
          },
        ]}
      >
        <Typography align="center" paragraph>
          Are you sure you want to update this Environment?
        </Typography>
      </Modal>

      <Dialog
        open={isOpen}
        onClose={clickCloseBtn}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle id="form-dialog-title" onClose={clickCloseBtn}>
          Update Environment: {data ? data.name : ""}
        </DialogTitle>
        <DialogContent>
          <Form>
            <Form.Textbox
              label="Environment Name"
              name="name"
              onChange={onChange}
              size={12}
              value={form.values.name}
              required
              maxLength={50}
              error={form.errors.name}
            />
            <Form.Checkbox
              label="Is Active"
              name="isActive"
              onChange={onChange}
              size={6}
              value={form.values.isActive}
            />
          </Form>
        </DialogContent>
        <DialogActions>
          <Button onClick={clickCloseBtn} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmitButtonClick} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
